import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=8c271e0e&"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js&"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports